import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-admin';
export var ID = 'icon-admin';
/* eslint-disable max-len */

export var SVGAdmin = function SVGAdmin() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 20 13"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M4.55820108,10.69319 L4.55820108,10.6877245 C4.56093382,10.3761928 4.70030328,9.39514108 6.15685074,8.50153691 C6.42465872,8.13808323 6.64327748,7.64345829 6.8673617,7.07231679 C7.02312757,6.67880303 6.99853296,6.34267669 6.99853296,5.86171542 C6.99853296,5.50919268 7.06411859,4.94078391 6.97667108,4.62651944 C6.67880303,3.57168394 5.93003378,3.27928135 5.05282602,3.27928135 C4.17288552,3.27928135 3.42411628,3.57441668 3.12898096,4.63198491 C3.04153346,4.94078391   3.10711908,5.50919268 3.10711908,5.86171542 C3.10711908,6.34267669 3.08252447,6.68153576 3.23829034,7.07778226 C3.50609832,7.76096587 3.76297535,8.33757284 4.10456716,8.70375926 C2.77372548,8.94697263 1.87192311,9.64381992 1.26252332,9.91436063 C0.00546546892,10.4745712 0,11.0894364 0,11.0894364 L0,12.133341 L4.55820108,12.1306083 L4.55820108,10.69319"
  }), React.createElement("path", {
    d: "M13.9806695,7.44670141 C14.4534326,6.94114553 14.8114208,6.14865254 15.1803399,5.21132462 C15.3934932,4.6702432 15.3552349,4.20567834 15.3552349,3.54708933 C15.3552349,3.0606626 15.4481479,2.27910054 15.3279076,1.85006123 C14.9179974,0.398979232 13.8904893,0 12.6826206,0 C11.474752,0 10.4445111,0.401711966 10.0373337,1.8555267 C9.91709336,2.28183328 10.0100063,3.06339533 10.0100063,3.54708933 C10.0100063,4.20841107 9.97448079,4.67297593 10.1876341,5.21679009 C10.559286,6.15685074   10.9118087,6.946611 11.381839,7.45216688 C9.54817421,7.78829322 8.3102455,8.74475028 7.47676149,9.11640217 C5.74694057,9.88703328 5.73874237,10.7314482 5.73874237,10.7314482 L5.73874237,12.1661338 L19.6620245,12.1634011 L19.6620245,10.7314482 C19.6620245,10.7314482 19.6538263,9.88430055 17.9185399,9.11366943 C17.0768577,8.73928481 15.827998,7.77736228 13.9806695,7.44670141 Z"
  })));
};
/* eslint-disable max-len */

var Admin = function Admin(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGAdmin
  });
};

Admin.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Admin;